module.exports = __webpack_public_path__ + "img/page_title.6b2b212e.png";